<template>
    <!-- 智能手环报表管理－页面 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'wristRepord')">
            <div slot="header" v-if="getBtnByAuth('smartWristBinding') || getBtnByAuth('smartWristInout') || getBtnByAuth('smartWristStatistics')">
                <a-tabs :defaultActiveKey='defaultActiveKey' @change="callback" class="tradeRecord_tab">
                    <a-tab-pane v-if="getBtnByAuth('smartWristBinding')" tab="智能腕卡绑定信息" key="0" forceRender></a-tab-pane>
                    <a-tab-pane v-if="getBtnByAuth('smartWristInout')" tab="腕卡进出场信息" key="1"></a-tab-pane>
                    <a-tab-pane v-if="getBtnByAuth('smartWristStatistics')" tab="数据统计" key="2"></a-tab-pane>
                </a-tabs>
                <div v-if="type == 2">
                    <a-row class="pl40">
                        <a-col span="5" class="first-col mr40">
                            <div class="font-smaller">当前场内人数 ({{$moment().format('YYYY-MM-DD HH:mm:ss')}})</div>
                            <div class="font28">{{currentData !== null ? currentData.currentNumber : 0}}</div>
                        </a-col>
                        <a-col span="4">
                            <div class="font-smaller">儿童（人）</div>
                            <div class="font28">{{currentData !== null ? currentData.childNumber : 0}}</div>
                        </a-col>
                        <a-col span="4">
                            <div class="font-smaller">成人（人）</div>
                            <div class="font28">{{currentData !== null ? currentData.adultsNumber : 0}}</div>
                        </a-col>
                        <a-col span="4">
                            <div class="font-smaller">工作人员（人）</div>
                            <div class="font28">{{currentData !== null ? currentData.workerNumber : 0}}</div>
                        </a-col>
                    </a-row>
                </div>
                <a-form :form="form" layout="inline">
                    <div v-show="type == 0">
                        <a-form-item label="绑定日期">
                            <a-range-picker style="width:282px" format="YYYY/MM/DD" v-decorator="['consumeTime1',{initialValue: [moment(),moment()]}]" />
                        </a-form-item>
                        <a-form-item label="票券名称">
                            <a-input placeholder="请输入" v-decorator="['name']"></a-input>
                        </a-form-item>
                        <a-form-item label="会员手机号">
                            <a-input placeholder="请输入" v-decorator="['phone']"></a-input>
                        </a-form-item>
                        <a-form-item label="ID查询">
                            <a-input placeholder="请输入腕卡\IC\定位识别ID" v-decorator="['id']"></a-input>
                        </a-form-item>
                        <a-form-item label="操作人">
                            <a-input placeholder="请输入" v-decorator="['operator']"></a-input>
                        </a-form-item>
                        <a-form-item class="wrap-header-button">
                            <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                            <a-button @click="handleReset">重置</a-button>
                        </a-form-item>
                    </div>
                    <div v-show="type == 1">
                        <a-form-item label="记录日期">
                            <a-range-picker style="width:282px" format="YYYY/MM/DD" v-decorator="['consumeTime2',{initialValue: [moment(),moment()]}]" />
                        </a-form-item>
                        <a-form-item label="会员手机号">
                            <a-input placeholder="请输入" v-decorator="['mobile']"></a-input>
                        </a-form-item>
                        <a-form-item label="ID查询">
                            <a-input placeholder="请输入腕卡\IC\定位识别ID" v-decorator="['did']"></a-input>
                        </a-form-item>
                        <a-form-item label="事件类型">
                            <a-select allowClear placeholder="请选择" v-decorator="['inoutType']">
                                <a-select-option value="0" >进场</a-select-option>
                                <a-select-option value="1" >出场</a-select-option>
                                <a-select-option value="2" >临时离场</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item label="人员属性">
                            <a-select allowClear placeholder="请选择" v-decorator="['peopleType']">
                                <a-select-option value="1" >儿童</a-select-option>
                                <a-select-option value="2" >大人</a-select-option>
                                <a-select-option value="3" >工作人员</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item class="wrap-header-button">
                            <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                            <a-button @click="handleReset">重置</a-button>
                        </a-form-item>
                    </div>
                </a-form>
            </div>

            <div class="wrist-header" v-if="type != 2">
                <div class="item" v-if="type == 0">
                    <div class="left">
                        <p class="text-color-45">票券核销</p>
                        <span class="font-biggest">{{currentDataTicket.bindNumber | formatStr}}</span>
                    </div>
                    <div class="right text-right">
                        <p class="text-color-45">大人：<a-tag color="blue">{{currentDataTicket.adultsNumber | formatStr}}</a-tag></p>
                        <p class="text-color-45">儿童：<a-tag color="red">{{currentDataTicket.childRedNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="purple">{{currentDataTicket.childNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="orange">{{currentDataTicket.childYellowNumber | formatStr}}</a-tag></p>
                    </div>
                </div>
                <div class="item" v-if="type == 0">
                    <div class="left">
                        <p class="text-color-45">绑定中</p>
                        <span class="font-biggest">{{currentDataTicket.bindiNumber | formatStr}}</span>
                    </div>
                    <div class="right text-right">
                        <p class="text-color-45">大人：<a-tag color="blue">{{currentDataTicket.adultsiNumber | formatStr}}</a-tag></p>
                        <p class="text-color-45">儿童：<a-tag color="red">{{currentDataTicket.childiRedNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="purple">{{currentDataTicket.childiNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="orange">{{currentDataTicket.childiYellowNumber | formatStr}}</a-tag></p>
                    </div>
                </div>
                <div class="item" v-if="type == 0">
                    <div class="left">
                        <p class="text-color-45">已解绑</p>
                        <span class="font-biggest">{{currentDataTicket.unBindNumber | formatStr}}</span>
                    </div>
                    <div class="right text-right">
                        <p class="text-color-45">大人：<a-tag color="blue">{{currentDataTicket.unAdultsNumber | formatStr}}</a-tag></p>
                        <p class="text-color-45">儿童：<a-tag color="red">{{currentDataTicket.unChildRedNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="purple">{{currentDataTicket.unChildNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="orange">{{currentDataTicket.unChildYellowNumber | formatStr}}</a-tag></p>
                    </div>
                </div>
                <div class="item" v-if="type == 1">
                    <div class="left">
                        <p class="text-color-45">腕卡绑定</p>
                        <span class="font-biggest">{{currentDataBvo.bindiNumber | formatStr}}</span>
                    </div>
                    <div class="right text-right">
                        <p class="text-color-45">大人：<a-tag color="blue">{{currentDataBvo.adultsiNumber | formatStr}}</a-tag></p>
                        <p class="text-color-45">儿童：<a-tag color="red">{{currentDataBvo.childiRedNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="purple">{{currentDataBvo.childiNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="orange">{{currentDataBvo.childiYellowNumber | formatStr}}</a-tag></p>
                    </div>
                </div>
                <div class="item" v-if="type == 1">
                    <div class="left">
                        <p class="text-color-45">刷卡入场</p>
                        <span class="font-biggest">{{currentDataInout.inNumber | formatStr}}</span>
                    </div>
                    <div class="right text-right">
                        <p class="text-color-45">大人：<a-tag color="blue">{{currentDataInout.inAdultsNumber | formatStr}}</a-tag></p>
                        <p class="text-color-45">儿童：<a-tag color="red">{{currentDataInout.inChildRedNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="purple">{{currentDataInout.inChildNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="orange">{{currentDataInout.inChildYellowNumber | formatStr}}</a-tag></p>
                    </div>
                </div>
                <div class="item" v-if="type == 1">
                    <div class="left">
                        <p class="text-color-45">刷卡离场</p>
                        <span class="font-biggest">{{currentDataInout.outNumber | formatStr}}</span>
                    </div>
                    <div class="right text-right">
                        <p class="text-color-45">大人：<a-tag color="blue">{{currentDataInout.outAdultsNumber | formatStr}}</a-tag></p>
                        <p class="text-color-45">儿童：<a-tag color="red">{{currentDataInout.outChildRedNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="purple">{{currentDataInout.outChildNumber | formatStr}}</a-tag></p>
                        <p><a-tag color="orange">{{currentDataInout.outChildYellowNumber | formatStr}}</a-tag></p>
                    </div>
                </div>
            </div>

            <div style="background-color:#fff;padding: 8px 16px">
                <a-tabs v-show="type == 0" :activeKey="tabType" @change="changeTabs">
                    <a-button slot="tabBarExtraContent" @click="exportExcel()" :loading="loading">导出excel</a-button>
                    <a-tab-pane :key="0" tab="绑定中">
                        <a-table :loading="loading" style="word-break:break-all;" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                            <span slot="bindDevices" slot-scope="a,row">
                                <a-tag v-for="device in row.bindDevices" :key="device.id" :color="['','orange','purple','red','blue'][Number(device.deviceColor)]">{{device.deviceId}}</a-tag>
                            </span>
                            <span slot="buyType" slot-scope="buyType">{{['','线上','线下'][buyType]}}</span>
                            <span slot="bindTime" slot-scope="bindTime">{{bindTime || "-"}}</span>
                            <span slot="shopName" slot-scope="shopName">{{shopName || "-"}}</span>
                            <span slot="operator" slot-scope="operator">{{operator || "-"}}</span>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane :key="3" tab="已解绑">
                        <a-table :loading="loading" style="word-break:break-all;" bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                            <span slot="bindDevices" slot-scope="a,row">
                                <a-tag v-for="device in row.bindDevices" :key="device.id" :color="['','orange','purple','red','blue'][Number(device.deviceColor)]">{{device.deviceId}}</a-tag>
                            </span>
                            <span slot="buyType" slot-scope="buyType">{{['','线上','线下'][buyType]}}</span>
                            <span slot="bindTime" slot-scope="bindTime">{{bindTime || "-"}}</span>
                            <span slot="shopName" slot-scope="shopName">{{shopName || "-"}}</span>
                            <span slot="operator" slot-scope="operator">{{operator || "-"}}</span>
                        </a-table>
                    </a-tab-pane>
                </a-tabs>
                <a-tabs v-show="type == 1" :activeKey="tabType" @change="changeTabs">
                    <a-button slot="tabBarExtraContent" @click="exportExcel()" :loading="loading">导出excel</a-button>
                    <a-tab-pane :key="1" tab="进出场">
                        <a-table :loading="loading" style="word-break:break-all;" bordered :dataSource="dataSource" :columns="columnsBraceletAndGate" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                            <span slot="inoutType" slot-scope="inoutType">{{['进场','出场','临时离场'][inoutType]}}</span>
                            <span slot="peopleType" slot-scope="peopleType">{{['','儿童','大人','工作人员'][peopleType]}}</span>
                        </a-table>
                    </a-tab-pane>
                    <a-tab-pane :key="4" tab="未进场">
                        <a-table :loading="loading" style="word-break:break-all;" bordered :dataSource="dataSource" :columns="columnsUnin" :pagination="pagination" @change="changePage" :rowKey="(record,index) => index">
                            <span slot="inoutType" slot-scope="inoutType">{{['进场','出场','临时离场'][inoutType]}}</span>
                            <span slot="peopleType" slot-scope="peopleType">{{['','儿童','大人','工作人员'][peopleType]}}</span>
                        </a-table>
                    </a-tab-pane>
                </a-tabs>
            </div>
            <a-card v-show="type == 2">
                <a-form :form="filterForm" slot="title" layout="inline">
                    <a-form-item label="日期">
                        <a-range-picker style="width:282px" format="YYYY/MM/DD" v-decorator="['consumeTime3',{initialValue: [moment(),moment()]}]" />
                    </a-form-item>
                    <a-form-item>
                        <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
                <a-button class="ml40" slot="extra" @click="exportExcel()" :loading="loading">导出excel</a-button>
                <a-table bordered :dataSource="dataSource" :columns="columnsBraceletConsume" :pagination="false" :rowKey="(record,index) => index">
                </a-table>
            </a-card>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
import moment from "moment";
export default {
    name: "wristRepord",
    components: {},
    props: {},
    data() {
        const columns = [
        {
            title: "会员手机号",
            dataIndex: "mobile"
        },
        {
            title: "票券渠道",
            dataIndex: "buyType",
            scopedSlots: { customRender: "buyType" }
        },
        {
            title: "票券名称",
            dataIndex: "name"
        },
        {
            title: "绑定标识",
            dataIndex: "bindDevices",
            scopedSlots: { customRender: "bindDevices" }
        },
        {
            title: "绑定时间",
            dataIndex: "bindTime",
            scopedSlots: { customRender: "bindTime" }
        },
        {
            title: "门店名称",
            dataIndex: "shopName",
            scopedSlots: { customRender: "shopName" }
        },
        {
            title: "操作人",
            dataIndex: "operator",
            scopedSlots: { customRender: "operator" }
        },
        ];
        const columnsBraceletAndGate = [
            {
                title: "记录ID",
                dataIndex: "id",
            },
            {
                title: "设备ID",
                dataIndex: "deviceId"
            },
            {
                title: "人员属性",
                dataIndex: "peopleType",
                scopedSlots: { customRender: "peopleType" }
            },
            {
                title: "手机号",
                dataIndex: "mobile"
            },
            {
                title: "事件类型",
                dataIndex: "inoutType",
                scopedSlots: { customRender: "inoutType" }
            },
            {
                title: "记录时间",
                dataIndex: "recordTime"
            },
            {
                title: "门店名称",
                dataIndex: "shopName"
            },
        ];
        const columnsUnin = [
            {
                title: "设备ID",
                dataIndex: "deviceId"
            },
            {
                title: "人员属性",
                dataIndex: "peopleType",
                scopedSlots: { customRender: "peopleType" }
            },
            {
                title: "手机号",
                dataIndex: "mobile"
            },
            {
                title: "绑定时间",
                dataIndex: "bindTime"
            },
            {
                title: "门店名称",
                dataIndex: "shopName"
            },
        ];
        const columnsBraceletConsume = [
        {
            title: "日期",
            dataIndex: "staticsDay",
        },
        {
            title: "绑定人数",
            dataIndex: "bindNumber"
        },
        {
            title: "进场人数",
            dataIndex: "inNumber"
        },
        {
            title: "离场人数",
            dataIndex: "outNumber"
        },
        {
            title: "门店名称",
            dataIndex: "shopName"
        },
        ];
        return {
            columns,
            columnsBraceletAndGate,
            columnsBraceletConsume,
            columnsUnin,
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            },
            type: 0,
            loading: false,
            bindNum: 0,
            gatesEnteredNum: 0,
            gatesOutNum: 0,
            defaultActiveKey: 1,
            adultNum: 0,
            babyNum: 0,
            currentData: {},
            currentDataTicket: {},
            currentDataBvo: {},
            currentDataInout: {},
            tabType: 0, // 0:绑定中 1:进出场 2:数据统计 3:已解绑 4:未进场
        };
    },
    computed: {
        ...mapGetters(["shopId"])
    },
    methods: {
        moment,
        callback(key) {
            this.type = key;
            this.tabType = key;
            
            switch (key) {
                case '0':
                    this.tabType = 0
                    this.columns[3].title = '绑定标识';
                    this.columns[4].title = '绑定时间';
                    break;
                case '1':
                    this.tabType = 1
                    break;
                case '3':
                    this.columns[3].title = '解绑标识';
                    this.columns[4].title = '解绑时间';
                    break;
            
                default:
                    break;
            }
            this.getList()
        },
        changePage(page) {
            this.pagination.pageSize = page.pageSize
            this.pagination.current = page.current
            this.getList()
        },
        handleReset () {
            this.form.resetFields();
        },
        search() {
            this.pagination.current = 1;
            this.getList();
        },
        changeTabs(e) {
            this.tabType = e;
            switch (e) {
                case 0:
                    this.columns[3].title = '绑定标识';
                    this.columns[4].title = '绑定时间';
                    break;
                case 3:
                    this.columns[3].title = '解绑标识';
                    this.columns[4].title = '解绑时间';
                    break;
            
                default:
                    break;
            }
            this.getList()
        },
        getInoutstcsCount() {
            if(!this.shopId) return
            this.$api.statement.inoutstcsCount({
                params: {
                    shopId: this.shopId
                }
            })
            .then(res => {
                this.currentData = res
            })
        },
        // 获取不同类型页面下的筛选条件
        getValuesForm() {
            let valuesForm = {};
            if(this.type == 2) {
                this.filterForm.validateFields((err, values) => {
                    const consumeTime = values['consumeTime3'] ? values['consumeTime3'] : []
                    valuesForm.beginDay = consumeTime.length > 0 ? consumeTime[0].format('YYYY-MM-DD') : ''
                    valuesForm.endDay = consumeTime.length > 0 ? consumeTime[1].format('YYYY-MM-DD') : ''
                })
            }else if(this.type == 0) {
                this.form.validateFields((err, values) => {
                    const consumeTime = values['consumeTime1'] ? values['consumeTime1'] : []
                    valuesForm.beginTime = consumeTime.length > 0 ? consumeTime[0].format('YYYY-MM-DD') : ''
                    valuesForm.endTime = consumeTime.length > 0 ? consumeTime[1].format('YYYY-MM-DD') : ''
                    
                    valuesForm.phone = values.phone
                    valuesForm.id = values.id
                    valuesForm.name = values.name
                    valuesForm.operator = values.operator
                });
            }else if(this.type == 1) {
                this.form.validateFields((err, values) => {
                    const consumeTime = values['consumeTime2'] ? values['consumeTime2'] : []
                    valuesForm.beginDay = consumeTime.length > 0 ? consumeTime[0].format('YYYY-MM-DD') : ''
                    valuesForm.endDay = consumeTime.length > 0 ? consumeTime[1].format('YYYY-MM-DD') : ''
                    
                    valuesForm.mobile = values.mobile
                    valuesForm.did = values.did
                    valuesForm.inoutType = values.inoutType
                    valuesForm.peopleType = values.peopleType
                });
            }
                    
            valuesForm.shopId = this.shopId
            return valuesForm
        },
        getList() {
            if(!this.shopId) return
            let valuesForm = this.getValuesForm();
            let type = Number(this.tabType);
            this.dataSource = [];
            this.loading = true;

            this.$api.statement[['wristZnList','wristInoutList','inoutstcsList','wristZnunlist','wristInoutUnList'][type]]({
                body: Object.assign(valuesForm, {
                    pageNum: this.pagination.current,
                    pageSize: this.pagination.pageSize
                })
            })
            .then(res => {
                this.loading = false;
                this.dataSource = res.data
                this.pagination.total = res.total
                if(type == 0) {
                    this.adultNum = res.adultNum;
                    this.babyNum = res.babyNum;
                }
            }).catch(err => {
                this.loading = false;
            })

            if(this.type == 0) {
                this.$api.statement.ticketStatics({
                    body: valuesForm
                })
                .then(res => {
                    this.currentDataTicket = res
                })
            }
            if(this.type == 1) {
                this.$api.statement.inoutStatics({
                    body: valuesForm
                })
                .then(res => {
                    this.currentDataBvo = res.bvo;
                    this.currentDataInout = res.inout;
                })
            }
        },
        exportExcel() {
            let valuesForm = this.getValuesForm();
            if(this.tabType == 0 || this.tabType == 1) {
                valuesForm.mark = 1;
            }else if(this.tabType == 3 || this.tabType == 4) {
                valuesForm.mark = 2;
            }
            this.loading = true;
            this.$api.statement[['wristZnExport','wristInoutExport','inoutstcsExport'][this.type]]({
                body: Object.assign(valuesForm, {
                    pageNum: 1,
                    pageSize: 99999999
                })
            },
            {
                responseType: "blob"
            })
            .then(res => {
                let a = document.createElement("a");
                let blob = new Blob([res.data], {
                    type: "application/vnd.ms-excel"
                });

                this.downloadUrl = window.URL.createObjectURL(blob);

                let str = ['智能腕卡绑定信息','腕卡进出场信息','数据统计'][this.type]
                let name = str + '-' + moment().format('YYYY/MM/DD') + '.xlsx'

                a.setAttribute("href", this.downloadUrl);

                var reportName = decodeURI(name);

                a.setAttribute("download", reportName);
                a.click();
                this.loading = false
            }).catch(err => {
                this.loading = false
            })
        },
    },
    beforeCreate() {
        this.form = this.$form.createForm(this);
        this.filterForm = this.$form.createForm(this);
    },
    mounted() {
        this.getList();
    },
	filters: {
        formatStr (val) {
            return (val || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
        }
    },
    watch: {
        type(val) {
            if(val == 2) {
                this.getInoutstcsCount()
            }
        },
        'shopId'(val) {
            if(this.type == 2) {
                this.getInoutstcsCount()
            }
            this.getList()
        }
    }
};
</script>
<style lang="scss">
    .font28 {
        margin-top: 3px;
        font-size: 28px;
        font-weight: 500;
        color: #666;
    }
    .first-col {
        border-right: 1px solid #ccc;
    }
    .wrist-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;
        .item {
            display: flex;
            justify-content: space-between;
            padding: 16px 8px 8px 16px;
            width: 32%;
            border-radius: 4px;
            background-color: #fff;
            >div {
                .text-color-45 {
                    color: $text-color-black-45;
                }
            }
            .right {
                width: 60%;
                >p {
                    margin-bottom: 8px;
                }
                .ant-tag {
                    width: 80px;
                }
            }
        }
    }
</style>